import { useState } from "react";
import { es, enUS } from "date-fns/locale";
import { getLang } from "@/i18n/translator";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarDays, X } from "lucide-react";
import { fmtDate } from "@/lib/format";

const pad = (n) => String(n).padStart(2, "0");
const toDate = (s) => (s ? new Date(`${s}T12:00:00`) : undefined);
const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export function DateInput({ value, onChange, id, testid, disabled, className = "", placeholder = "Seleccione fecha", ariaLabel, clearable = true }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className={`relative ${className}`}>
        <PopoverTrigger asChild>
          <button type="button" id={id} data-testid={testid} disabled={disabled} aria-label={ariaLabel}
            className="field-input flex items-center gap-2 pr-8 text-left">
            <CalendarDays className="h-4 w-4 shrink-0 text-slate-400" />
            <span className={`truncate ${value ? "" : "text-slate-400"}`} data-testid={testid && `${testid}-value`}>{value ? fmtDate(value) : placeholder}</span>
          </button>
        </PopoverTrigger>
        {value && !disabled && clearable && (
          <button type="button" aria-label="Borrar fecha" onClick={() => onChange("")} data-testid={testid && `${testid}-clear`}
            className="absolute right-2 top-2.5 text-slate-400 hover:text-slate-700"><X className="h-4 w-4" /></button>
        )}
      </div>
      <PopoverContent className="w-auto bg-white p-0" align="start" data-testid={testid && `${testid}-calendar`}>
        <Calendar mode="single" locale={getLang() === "en" ? enUS : es} weekStartsOn={1} selected={toDate(value)} defaultMonth={toDate(value)} initialFocus
          formatters={{ formatCaption: (m) => { const s = m.toLocaleDateString(getLang() === "en" ? "en-US" : "es-US", { month: "long", year: "numeric" }); return s.charAt(0).toUpperCase() + s.slice(1); } }}
          onSelect={(d) => { if (d) { onChange(toISO(d)); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
